// Copyright © Veeam Software Group GmbH

import React from 'react';
import { useRouter } from '@veeam/core';

import type { ReactElement } from 'react';

import { Routes } from 'infrastructure/routing';
import { ExplorePage } from 'pages/ExplorePage';
import { RestoreSessionsPage } from 'pages/RestoreSessionsPage';
import { RestoreListPage } from 'pages/RestoreListPage';

export function useRouting(): ReactElement | null {
    const { content } = useRouter({
        match: {
            [Routes.Explore]: () => <ExplorePage />,
            [Routes.RestoreSessions]: () => <RestoreSessionsPage />,
            [Routes.RecoveryList]: () => <RestoreListPage />,
        },
    });
    return content;
}
